const EXT_BUCKETS = {
  "text-emerald-400": new Set(["sh", "bash", "zsh", "fish"]),
  "text-sky-400": new Set(["json", "yaml", "yml", "csv", "tsv", "xml", "toml"]),
  "text-blue-400": new Set(["cfg", "ini", "env", "conf", "properties", "lock"]),
  "text-orange-400": new Set(["html", "css", "scss", "md", "mdx", "rst"]),
  "text-violet-400": new Set([
    "js", "jsx", "ts", "tsx", "py", "go", "rb", "rs", "java", "kt", "swift",
    "c", "cpp", "h", "hpp", "cs", "php", "sql", "graphql", "proto", "lua", "pl",
  ]),
};

function pickExtColor(ext) {
  const e = (ext || "").toLowerCase();
  for (const [color, set] of Object.entries(EXT_BUCKETS)) {
    if (set.has(e)) return color;
  }
  return "text-zinc-400";
}

export function FileExtIcon({ ext, className = "w-7 h-7" }) {
  const label = (ext || "").slice(0, 4).toUpperCase();
  const color = pickExtColor(ext);
  return (
    <svg
      viewBox="0 0 24 28"
      className={`${className} ${color}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3 2h12l6 6v17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"
        fill="currentColor"
        opacity="0.9"
      />
      <path d="M15 2v6h6z" fill="currentColor" opacity="0.5" />
      <text
        x="11.5"
        y="21"
        textAnchor="middle"
        fontSize="6"
        fontWeight="800"
        fill="white"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
      >
        {label}
      </text>
    </svg>
  );
}
